<template>
  <div class="page-wrapper">
    <art-detail detail-type="home" :back-func="handleBack"></art-detail>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import ArtDetail from "@/components/ArtDetail/index";
  export default {
    name: "HomeArtDetail",
    components: {ArtDetail},
    data() {
      return {
        loading: true
      }
    },
    computed: {
      ...mapState({
        userInfo: state => state.userInfo
      })
    },

    methods: {
      handleBack() {
        this.$router.replace('/')
      }
    },

    created() {

    },
  }
</script>

<style lang="scss" scoped>
  .page-wrapper {
    padding: 30px;
  }

  .demo {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
